import type { IconData } from '@stacksjs/iconify-core'

export const toiletWomenSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 15a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m-3.977 1.688A39 39 0 0 1 24 16.5a39 39 0 0 1 3.978.188c1.519.158 2.779 1.102 3.467 2.429c1.32 2.543 3.654 7.438 5.23 12.998c.577 2.037-.889 4.004-2.98 4.123q-1.077.063-2.462.12l-.548 6.847c-.128 1.596-1.332 2.925-2.958 3.09q-.463.047-.98.088a1.48 1.48 0 0 1-1.59-1.415l-.364-7.99a.5.5 0 0 0-.499-.478h-.589a.5.5 0 0 0-.5.477l-.363 7.99a1.48 1.48 0 0 1-1.59 1.416a45 45 0 0 1-.98-.088c-1.626-.165-2.83-1.494-2.957-3.09l-.548-6.847a145 145 0 0 1-2.463-.12c-2.09-.119-3.556-2.086-2.98-4.123c1.577-5.56 3.91-10.455 5.23-12.998c.689-1.327 1.948-2.271 3.468-2.429Z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletWomenSolid
